// Gebündelter Public-Fetch für den Login-Screen: /api/auth/bootstrap liefert
// domaincheck + auth_settings + signup_config in EINEM Roundtrip (statt drei
// Einzel-Calls). Modul-weiter Promise-Cache, damit SigninClient und
// useAuthSettings denselben Request teilen statt doppelt zu fetchen.
let bootstrapPromise = null;

export function fetchAuthBootstrap() {
  if (!bootstrapPromise) {
    bootstrapPromise = fetch('/api/auth/bootstrap', {
      method: 'GET',
      headers: { Accept: 'application/json' },
      // credentials: 'omit' — keine (evtl. stale) Cookies an den Public-Endpoint,
      // gleiche Begründung wie bei den bisherigen Einzel-Calls (Redirect-Loops).
      credentials: 'omit',
    })
      .then((response) => {
        if (!response.ok) throw new Error(`auth-bootstrap HTTP ${response.status}`);
        return response.json();
      })
      .catch((err) => {
        // Fehlgeschlagenen Versuch nicht cachen — Konsumenten fallen auf ihre
        // Einzel-Endpoints zurück, der nächste Aufrufer probiert es neu.
        bootstrapPromise = null;
        throw err;
      });
  }
  return bootstrapPromise;
}
